import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoadingIndicatorComponent } from './loading-indicator.component';

@NgModule({
  imports: [CommonModule],
  exports: [LoadingIndicatorComponent],
  declarations: [LoadingIndicatorComponent],
  providers: [],
})
export class LoadingIndicatorModule {}
